import { hideOrShowNavSectionOnScroll } from '../../util/scroll';
import { mobileNavNewsletterFormHeight } from '../../../css/redesign/exports/misc.scss';
window.up.compiler('.js-mobile_navigation_newsletter_form', nav => hideOrShowNavSectionOnScroll('mobile', nav, parseInt(mobileNavNewsletterFormHeight, 10), 'mobile_navigation__newsletter_form--hidden'));
